<template>
  <div class="about" id="about">
    <div class="container">
      <h1>
        <font-awesome-icon icon="info-circle"/>
        Mehr zur Feuerwehr Pfaffenhofen
      </h1>
      <p class="text">
        Pfaffenhofen ist eine 3800 Einwohner Gemeinde und liegt im Landkreis Neu-Ulm (Bayern).
        Insgesamt hat die Marktgemeinde 7000 Einwohner. 
        <br><br>
        Einsatzschwerpunkte sind die Staatsstraßen und Industriebetriebe. 
        Auch überörtlich ist die Feuerwehr Pfaffenhofen in Einsatzplänen vermerkt.
      </p>
      <br>
      <div class="pagination">
        <div class="swiper-pagination" slot="pagination"></div>
      </div>
      <div class="swiper-wrapper">
        <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide  v-for="item in content" :key="item.title">
          <div class="wrapper">
            <div class="content">
              <div class="image-container">
                <router-link :to="item.link_to">
                  <img :src="item.cover_url" width="420px">
                </router-link>
              </div>
                <p class="title">
                  <router-link :to="item.link_to">{{ item.title }}</router-link>
                </p>
                <p class="body">{{ item.description }}</p>
            </div>
          </div>
        </swiper-slide>
        <!-- Optional controls -->
        <div class="swiper-button-prev" slot="button-prev">
          <font-awesome-icon  class="slider-icon" icon="chevron-left"/>
        </div>
        <div class="swiper-button-next" slot="button-next">
          <font-awesome-icon class="slider-icon" icon="chevron-right"/>
        </div>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'HomeAbout',
  components: {
    swiper, swiperSlide
  },
  data() {
      return {
        content: [
        {
          title: 'Fahrzeuge',
          description: 'Mehr Information zu den Fahrzeugen der Feuerwehr Pfaffenhofen.',
          cover_url: '/card-covers/vehicles.jpg',
          link_to: 'fahrzeug'
        },
        {
          title: 'Standort und Gerätehaus',
          description: 'Mehr Informationen zum Standort und Gerätehaus der Feuerwehr Pfaffenhofen.',
          cover_url: '/card-covers/site.jpg',
          link_to: 'standort'
        },
        {
          title: 'Mannschaft',
          description: 'Informationen zur aktiven Mannschaft der Feuerwehr.',
          cover_url: '/card-covers/group.jpg',
          link_to: 'group'
        },
        {
          title: 'Jugendgruppe',
          description: 'Informationen zur Jugendgruppe der Feuerwehr',
          cover_url: '/card-covers/youth.jpg',
          link_to: 'jugend'
        },
        {
          title: 'Alarmierung',
          description: 'Mehr Informationen zu Alamierungen im Einsatzfall.',
          cover_url: '/card-covers/alarm.jpg',
          link_to: 'alarm'
        }
        ],
        swiperOption: {
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          spaceBetween: 50,
          slidesPerView: 2,
          loop: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
           breakpoints: {
            950: {
              slidesPerView: 1
            },
          }
        }
      }
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper
      }
    }
}
</script>

<style lang="scss" scoped>
@import "../styles/theme.scss";
.swiper-button-prev {
  background: none;
  left: 0px;
  top: 40%;
}

.swiper-button-next {
  background: none;
  top: 40%;
}

.swiper-pagination-bullet-active {
  background: $primary-0;
}

.swiper-pagination-bullet {
  margin: 0px 2px;
}

.about {
  background: $light-1;
  width: 100%;
  padding-bottom: 50px;
}

.container {
  padding: 0;
}

h1 {
  color: $dark;
  font-size: 20px;
  text-align: center;
  margin-top: 0;
  padding-top: 60px;

  svg {
    color: $primary-0;
    font-size: 38px;
    margin-right: 15px;
  }

  @include mini {
    font-size: 30px;
  }
}

.contact {
  background: $primary;
}

h1, p {
  text-align: center;
}

h1 {
  color: $dark;
  font-size: 20px;

  @include mini {
    font-size: 30px;
  }
}

.text {
  color: $dark;
  opacity: 0.8;
  padding: 0px 10px;
}

.pagination {
  margin-bottom: 5px;

  @include desktop {
    padding-right: 60px;
  }
}

.swiper-pagination {
  position: relative;

  @include desktop {
    text-align: right;
  }
}

.swiper-pagination-bullet {
  padding: 0px 5px;
}

.image-container {
  display: flex;
  align-content: center;
  justify-content: center;
}


h1, p {
  text-align: center;
}
.title {
  color: $dark;
  font-weight: bold;
  font-size: 20px;

  a {
    text-decoration: none;
    color: $dark;

    &:hover {
      color: $primary-0;
    }
  }
}

.body {
  color: $dark;
  opacity: 0.8;
  margin: 0px 20px;
}

.slider-icon {
  position: absolute;
  width: 40px;
  height: 40px;
  border-radius: 30px;
  border: none;
  cursor: pointer;
  color: $light-0;

  &:hover {
    opacity: 1;
    color: $primary-0;
  }

  opacity: 0.7;

  @include mini {
    color: $dark;
  }

}
</style>
